import type { ReactNode } from 'react';

export const symbol_chat_bubble_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M880-820v551q0 12.75-8.57 21.37-8.58 8.63-21.25 8.63-11.18 0-20.68-7.75T820-270v-550H250q-15 0-22.5-9.32t-7.5-20.5q0-11.18 7.5-20.68T250-880h570q23 0 41.5 18.5T880-820ZM240-240 131-131q-14 14-32.5 6.34Q80-132.31 80-152v-657l-3-3q-9-9-9-20.5t8.5-20.5q8.5-9 21-9.5T119-854L882-91q9 9 8.5 21T881-49q-9 9-21 9t-21-9L648-240H240Zm289-290Zm-165 5ZM140-749v529l74-80h374L140-749Z"
		/>
	</svg>
);
